/**
 * 商品栄養成分情報メンテナンス画面起動時の入力情報を格納するVO
 *
 */
export class KYMW1107InputModel {
  /** 画面ＩＤ */
  public formId: string = <string>'';

  /** Ｐコード */
  public pCode: string = <string>'';

  /** アイテムコード */
  public itemCode: string = <string>'';

  /** 商品案内用商品名 */
  public guideGoodsName: string = <string>'';

  /** 商品案内用規格名 */
  public guideStandardName: string = <string>'';

  /** 分析連番 */
  public analysisSeqNo: string = <string>'';
}
